import initialState from '../initialState.js';
import {
    SET_FORM_FIELD,
    ADD_DEPENDENT,
    ADD_BENEFICIARY,
    EDIT_DEPENDENT,
    REMOVE_DEPENDENT,
    REMOVE_BENEFICIARY,
    EDIT_BENEFICIARY,
    SAVE_INIT_DATA,
    SAVE_EXPECTED_DATA,
    SAVE_LOCAL_COPY, 
    RESET_SIGNUP
} from '../../actions/types/signup';
import * as session from '../../services/session.js';

export default (state = initialState.signup, action) => {
    switch (action.type) {
        case SAVE_LOCAL_COPY: {
            session.saveEnrollmentData(state);

            return {
                ...state
            };
        }

        case SAVE_INIT_DATA: {
            const data = action.data;
            delete data.spendingAccount;

            return {
                ...state,
                userDetails: {
                    ...data,
                    firstname: '',
                    lastname: '',
                    expectedFirstname: data.firstname,
                    expectedLastname: data.lastname
                }
            };
        }

        case SAVE_EXPECTED_DATA: {
            const data = action.data;

            return {
                ...data.savedEnrollment,
                userDetails: {
                    ...data.savedEnrollment.userDetails,
                    firstname: data.savedEnrollment.userDetails.firstname,
                    lastname: data.savedEnrollment.userDetails.lastname,
                    expectedFirstname: data.response.firstname,
                    expectedLastname: data.response.lastname
                }
            };
        }

        case SET_FORM_FIELD: {
            return {
                ...state,
                [action.section]: {
                    ...state[action.section],
                    [action.key]: action.value
                }
            };
        }

        case ADD_DEPENDENT: {
            return {
                ...state,
                dependents: [
                    ...state.dependents,
                    action.dependent
                ]
            };
        }

        case EDIT_DEPENDENT: {
            return {
                ...state,
                dependents: state.dependents.map((item, i) => {
                    if (i === action.index) {
                        return action.dependent;
                    }

                    return item;

                })
            };
        }

        case REMOVE_DEPENDENT: {
            return {
                ...state,
                dependents: state.dependents.filter((item, i) => i !== action.index)
            };
        }

        case ADD_BENEFICIARY: {
            if (action.isContingent) {
                return {
                    ...state,
                    beneficiaries: {
                        ...state.beneficiaries,
                        contingent: [
                            ...state.beneficiaries.contingent,
                            action.beneficiary
                        ]
                    }
                };
            }

            return {
                ...state,
                beneficiaries: {
                    ...state.beneficiaries,
                    primary: [
                        ...state.beneficiaries.primary,
                        action.beneficiary
                    ]
                }
            };
        }

        case EDIT_BENEFICIARY: {
            if (action.isContingent) {
                return {
                    ...state,
                    beneficiaries: {
                        ...state.beneficiaries,
                        contingent: state.beneficiaries.contingent.map((item, i) => {
                            if (i === action.index) {
                                return action.beneficiary;
                            }

                            return item;

                        })
                    }
                };
            }

            return {
                ...state,
                beneficiaries: {
                    ...state.beneficiaries,
                    primary: state.beneficiaries.primary.map((item, i) => {
                        if (i === action.index) {
                            return action.beneficiary;
                        }

                        return item;

                    })
                }
            };
        }

        case REMOVE_BENEFICIARY: {
            if (action.isContingent) {
                return {
                    ...state,
                    beneficiaries: {
                        ...state.beneficiaries,
                        contingent: state.beneficiaries.contingent.filter((item, i) => i !== action.index)
                    }
                };
            }

            return {
                ...state,
                beneficiaries: {
                    ...state.beneficiaries,
                    primary: state.beneficiaries.primary.filter((item, i) => i !== action.index),
                    // If we are removing the last remaining primary beneficiary then there can be no contingent beneficiaries
                    contingent: state.beneficiaries.primary.length === 1 ? [] : state.beneficiaries.contingent
                }
            };
        }

        case RESET_SIGNUP: {
            return {
                ...state,
                dependents: [],
                beneficiaries: {
                    primary: [],
                    contingent: []
                },
                trustee: null,
                signup: {
                    beneficiaries: {
                        contingent: [],
                        primary: []
                    },
                    dependents: [],
                    spendingAccounts: {
                        hsaAmount: 0,
                        lsaAmount: 0
                    },
                    trustee: null,
                    saved: {},
                    userDetails: null
                }
            };
        }

        default:
            return state;
    }
};